import { ArchetypeConfig } from "../../schema";

/**
 * Simple Residential archetypes.
 */
export const defaultSimpleResidentialArchetypes: ArchetypeConfig[] = [
  {
    id: "freestanding-house",
    name: "Freestanding House",
    value: "FreestandingHouse",
    category: "residential",
    service: "Residential Building",
    description: "A single, stand alone house.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "cf206666-729a-4f18-ab76-7c2ac483e148",
    },
  },
  {
    id: "high-rise-flat",
    name: "High Rise Flat",
    value: "HighRiseFlat",
    category: "residential",
    service: "Residential Building",
    description:
      "Multi-storey apartment living dwelling, characteristics of a 5+ storeys building. Shared spaces and equipment where part of the apartment value rests in shared asset(s).",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "18c44475-90d4-4c00-a13e-293e9565f53d",
    },
  },
  {
    id: "low-rise-flat",
    name: "Low Rise Flat",
    value: "LowRiseFlat",
    category: "residential",
    service: "Residential Building",
    description:
      "Multi-storey apartment living dwelling, characteristics of less than 5 storeys building. Shared spaces and equipment where part of the apartment value rests in shared asset(s).",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "3f4b946d-16f3-4d57-a891-6620d128f703",
    },
  },
  {
    id: "medium-density-attached",
    name: "Medium Density Attached",
    value: "MediumDensityAttached",
    category: "residential",
    service: "Residential Building",
    description:
      "A Medium Density Attached is built from the 1960's onwards, generally of brick veneer construction with either a tiled or tin roof and 1 shared wall with the adjacent house, single storey.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "35db7f8a-4632-4088-b252-7fb6b0c91390",
    },
  },
  {
    id: "medium-density-detached",
    name: "Medium Density Detached",
    value: "MediumDensityDetached",
    category: "residential",
    service: "Residential Building",
    description:
      "A Medium Density Detached is built from the 1960's onwards, generally of brick veneer construction with either a tiled or tin roof and single storey.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "2ba12613-887b-4958-8f58-2c667efd5eaf",
    },
  },
];

/**
 * Simple Commercial archetypes.
 */
export const defaultSimpleCommercialArchetypes: ArchetypeConfig[] = [
  {
    id: "simple-office",
    name: "Simple Office",
    value: "SimpleOffice",
    category: "commercial",
    service: "Commercial Building",
    description:
      "Simple Offices are generally multi storey commercial office buildings with elements such as generators or lifts.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "fec19151-b71c-47f8-be78-56c2093ac52d",
    },
  },
  {
    id: "low-rise-structure",
    name: "Low Rise Structure",
    value: "LowRiseStructure",
    category: "commercial",
    service: "Commercial Building",
    description:
      "Multi-storey office or commercial building, characteristics of less than 5 storeys building. Shared spaces and equipment where part of the structure value rests in shared asset(s), no lift.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "62ef0915-e4af-4363-a873-14cb145db1b9",
    },
  },
  {
    id: "high-rise-structure",
    name: "High Rise Structure",
    value: "HighRiseStructure",
    category: "commercial",
    service: "Commercial Building",
    description:
      "Multi-storey building of a more than 5 storeys. Contains basement and array of complex elements and mechanical components for lifts",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "ff343f59-3e11-463f-8661-d0ae34df23ae",
    },
  },
  {
    id: "supermarket",
    name: "Supermarket",
    value: "Supermarket",
    category: "commercial",
    service: "Commercial Building",
    description:
      "A type of retail construction that stores food and non-food products and generally exceeds 4,000-5,000 sqm.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "3b04d8f9-773e-4808-95db-0092286777dc",
    },
  },
];

/**
 * Simple Industrial archetypes.
 */
export const defaultSimpleIndustrialArchetypes: ArchetypeConfig[] = [
  {
    id: "advanced-water-treatment-plant",
    name: "Advanced Water Treatment Plant",
    value: "AdvancedWaterTreatment",
    category: "industrial",
    service: "Water Supply",
    description:
      "An advanced water treatment plant utilising sophisticated technologies to purify wastewater or other water sources beyond the capabilities of conventional treatment plants.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "c8a37750-6117-4c27-bd82-1428816c5cba",
    },
  },
  {
    id: "ambulance-station",
    name: "Ambulance Station",
    value: "AmbulanceStation",
    category: "industrial",
    service: "Emergency",
    description:
      "An Ambulance Station is a designated location equipped with resources and communication systems to facilitate rapid response during emergencies",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "638aee10-b521-4cef-9773-366e02df9999",
    },
  },
  {
    id: "berth",
    name: "Berth",
    value: "Berth",
    category: "industrial",
    service: "Council",
    description:
      "A designated location where a vessel may be moored, usually for the purposes of loading and unloading",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "6c60cbd5-0507-4d80-a4f5-e86cc3d12186",
    },
  },
  {
    id: "control-room",
    name: "Control Room",
    value: "ControlRoom",
    category: "industrial",
    service: "Council",
    description:
      "A warehouse or factory used alongside large industrial operations, consisting of mainly electrical and electronic operating and power controls.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "f3f95bb7-86b5-4018-95fd-f4336f59eae8",
    },
  },
  {
    id: "data-center",
    name: "Data Centre",
    value: "DataCenter",
    category: "industrial",
    service: "Council",
    description: "A building containing a large number of networked computer servers.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "ef0a69ad-ac8a-43d8-b189-20087b6fb7d7",
    },
  },
  {
    id: "council-building",
    name: "Council Building",
    value: "CouncilBuilding",
    category: "industrial",
    service: "Council",
    description:
      "Multi-purpose use building that has major mechanical equipment like a lift or HVAC and general purpose electronic. Building types like library, community centre, depot, town hall, or a child care centre.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "9c2ec092-91fe-47fa-b270-39107bc75ade",
    },
  },
  {
    id: "fibre-junction",
    name: "Fibre Junction",
    value: "FibreJunction",
    category: "industrial",
    service: "Telecommunications",
    description: "Fibre optic telecommunications Node at the edge of the network.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "6440ef6c-8bc1-4000-955c-83ba5a068447",
    },
  },
  {
    id: "fibre-node",
    name: "Fibre Node",
    value: "FibreNode",
    category: "industrial",
    service: "Telecommunications",
    description: "Fibre optic telecommunications network Node.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "e5089442-5081-4902-b1b6-1f18859d4103",
    },
  },
  {
    id: "flexible-road-pavement",
    name: "Flexible Road Pavement",
    value: "FlexiblePavement",
    category: "industrial",
    service: "Roads",
    description:
      "Flexible pavement is a type of road surface generally made of layers of bituminous materials over an aggregate base.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "2eadd1ef-fd6d-4153-ad40-f99541836286",
    },
  },
  {
    id: "gas-distribution",
    name: "Gas Distribution",
    value: "GasDistribution",
    category: "industrial",
    service: "Gas Supply",
    description:
      "Gas distribution stations are critical infrastructure that reduce the high pressure of natural gas from transmission pipelines to suitable levels for delivery to consumers, typically featuring pressure regulators, safety features, and automated control systems.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "c9c6ff77-5012-4967-b30c-0a3fb6645bdb",
    },
  },
  {
    id: "generic-industrial",
    name: "Generic Industrial Building",
    value: "GenericIndustrial",
    category: "industrial",
    service: "Council",
    description:
      "For an unknown archetype, generic industrial can be used. Likely an operational building or warehouse.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "ca148596-6eb4-4fef-b325-b354e0508146",
    },
  },
  {
    id: "girder-bridge",
    name: "Girder Bridge",
    value: "Girder",
    category: "industrial",
    service: "Roads",
    description:
      "A girder bridge is a bridge that uses girders as the means of supporting its deck, generally made from steel.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "a9882f3e-9f73-4959-9138-fb26d8577611",
    },
  },
  {
    id: "hospital",
    name: "Hospital",
    value: "Hospital",
    category: "industrial",
    service: "Emergency",
    description:
      "A specialised facility designed to provide medical care, treatment, and support to patients. It typically consists of multiple interconnected sections and is built to accommodate a wide range of healthcare services.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "7ef251f4-7ff1-406c-859f-5f4b05e1bf30",
    },
  },
  {
    id: "maximum-vulnerability-archetype",
    name: "Maximum Vulnerability Archetype",
    value: "MaximumVulnerability",
    category: "industrial",
    service: "Council",
    description: "A fully exposed archetype without any structural asset present.",
    defaultHeightAboveGround: 0,

    embed: {
      type: "doc360",
      id: "402fd90d-e032-47bc-88bd-c3acb02e4df6",
    },
  },
  {
    id: "main-switchboard",
    name: "Main Switchboard",
    value: "MainSwitchboard",
    category: "industrial",
    service: "Council",
    description:
      "A large, enclosed cabinet or assembly of electrical panels designed to manage and distribute electricity safely and efficiently within a facility. It is typically located in a secure, access-controlled room.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "af93117b-375b-4efb-9476-37f1f4681d0b",
    },
  },
  {
    id: "overhead-power-pole",
    name: "Overhead Power Pole",
    value: "Overhead",
    category: "industrial",
    service: "Power",
    description: "An overhead power pole is a single pole carrying low voltage, medium voltage, or high voltage lines.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "c1e3f33e-52cf-48e1-9a33-bd46b3ddf180",
    },
  },
  {
    id: "park",
    name: "Park",
    value: "Park",
    category: "industrial",
    service: "Council",
    description:
      "Open space owned by council. Civil structures including paths and paving, playgrounds, seats, benches, signs and some minor electrical elements such as community BBQs.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "824f451d-690b-4862-9497-9f8be382ac90",
    },
  },
  {
    id: "park-complex",
    name: "Park Complex",
    value: "ParkComplex",
    category: "industrial",
    service: "Council",
    description: "Open green space that has complex elements such as irrigation or digital connectivity.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "795f5a65-fb4a-409b-a8b9-4b8cfa8df303",
    },
  },
  {
    id: "below-ground-gas-pipe",
    name: "Below Ground Gas Pipe",
    value: "Pipe",
    category: "industrial",
    service: "Gas Supply",
    description: "Underground pipe used to transport gas.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "eb7f2140-ddc4-4b45-aa19-488a3b438f9c",
    },
  },
  {
    id: "pressure-main-sewage-pipe",
    name: "Pressure Main Sewage Pipe",
    value: "PressureMain",
    category: "industrial",
    service: "Sewage",
    description:
      "A below ground main pressurised sewage pipe body connected to all branching pipes. Usually made of steel.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "8892f2da-f916-4f1e-aa6c-d8d375b0b5b4",
    },
  },
  {
    id: "prison",
    name: "Prison",
    value: "Prison",
    category: "industrial",
    service: "Emergency",
    description: "The build of this archetype is equivalent to a hospital without any chemical storage.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "799b08f7-5a2f-4090-82c8-631f2e643e6d",
    },
  },
  {
    id: "rigid-road-pavement",
    name: "Rigid Road Pavement",
    value: "RigidPavement",
    category: "industrial",
    service: "Roads",
    description:
      "Primarily concrete road surface used in heavy-duty areas like highways, airports, industrial roads, and ports.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "c84a3edf-8d6d-4e58-9dc9-b85e21f55e03",
    },
  },
  {
    id: "above-ground-sewage-pipe",
    name: "Above Ground Sewage Pipe",
    value: "RisingMain",
    category: "industrial",
    service: "Sewage",
    description:
      "An above ground pressurised main sewer pipe that is used to deliver sewage to another location. Has one civil element with exposures to wind as well as soil movement and landslide. ",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "24bfd926-4fe8-424d-a39d-802c4719b6fc",
    },
  },
  {
    id: "school",
    name: "School",
    value: "School",
    category: "industrial",
    service: "Council",
    description: "Building used for an educational institution.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "aa4a2bbd-cd34-4b67-86cb-90d601fde5c9",
    },
  },
  {
    id: "mechanical-sewage-treatment-plant",
    name: "Mechanical Sewage Treatment Plant",
    value: "SewageMechanised",
    category: "industrial",
    service: "Sewage",
    description: "Sewage treatment plant with mechanical separation of sludge from wastewater. ",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "32240143-a495-491a-86e3-17a16b70bc7e",
    },
  },
  {
    id: "shiploader",
    name: "Shiploader",
    value: "Shiploader",
    category: "industrial",
    service: "Council",
    description:
      "Sits on the Berth or Wharf to load bulk materials or cargo on or off the ship for transportation by sea.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "7c14f2d5-f480-472b-aa29-eaeb192fec4a",
    },
  },
  {
    id: "train-station-building",
    name: "Train Station Building",
    value: "Station",
    category: "industrial",
    service: "Rail",
    description: "Train station has multiple purposes including ticket functions and thoroughfare for platform usage.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "31a56a88-70a7-41a4-9d57-ef353cf3febf",
    },
  },
  {
    id: "stormwater-pit",
    name: "Stormwater Pit",
    value: "StormWaterPit",
    category: "industrial",
    service: "Council",
    description:
      "A Stormwater pit is an open civil structure that fills up with storm water. It collects surface water runoff and directs it to a drainage system.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "dbb15c5a-8308-4641-86c9-e87a8a021725",
    },
  },
  {
    id: "substation",
    name: "Substation",
    value: "Substation",
    category: "industrial",
    service: "Power",
    description: "Dedicated facility to step-up or step-down the voltage within an electrical power grid.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "2c1ac1e2-6542-4e9f-abf3-91af44c2e667",
    },
  },
  {
    id: "telecommunications-tower",
    name: "Telecommunications Tower",
    value: "Tower",
    category: "industrial",
    service: "Telecommunications",
    description:
      "Telecommunication tower is a tower for transmitting radio applications like television, radio, mobile phone or officials radio.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "e543ce8d-aca8-4527-8666-7df6b4ae4417",
    },
  },
  {
    id: "track-main",
    name: "Track Main",
    value: "TrackMain",
    category: "industrial",
    service: "Rail",
    description:
      "Refers to the principal track of a railway system, serving as the primary route connecting major locations",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "4b98a111-752f-4e14-b07b-c034803af78a",
    },
  },
  {
    id: "transformer",
    name: "Transformer",
    value: "Transformer",
    category: "industrial",
    service: "Power",
    description:
      "A transformer is a static device for stepping up or down electric voltage by inductive coupling between its windings. Power transformers are typically located within substations.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "9a99f63c-5ca2-4b2b-a060-97212ab5e7eb",
    },
  },
  {
    id: "truss-bridge",
    name: "Truss Bridge",
    value: "Truss",
    category: "industrial",
    service: "Roads",
    description:
      "A truss bridge is a bridge whose load-bearing superstructure is composed of a truss, a structure of connected elements, usually forming triangular units. Can be made from timber or steel.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "cd60974a-262f-487c-aaff-5acfc72565be",
    },
  },
  {
    id: "road-tunnel",
    name: "Road Tunnel",
    value: "Tunnel",
    category: "industrial",
    service: "Roads",
    description: "Tunnels similar archetypes to bridges but with different element exposures and vulnerabilities. ",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "347cddef-e10c-472f-8c99-881ae5863b80",
    },
  },
  {
    id: "aerated-sewage-treatment-pond",
    name: "Aerated Sewage Treatment Pond",
    value: "AeratedLagoon",
    category: "industrial",
    service: "Sewage",
    description: "Sewage treatment pond with artificial aerators.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "bcc85841-24bc-4545-9845-c689be8815e0",
    },
  },
  {
    id: "oxidation-sewage-treatment-pond",
    name: "Oxidation Sewage Treatment Pond",
    value: "NaturalLagoon",
    category: "industrial",
    service: "Sewage",
    description: "Sewage treatment pond using aerobic bacteria and algae to break down wastewater (oxidation).",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "b72e2bd7-3ba1-4d47-b20b-6cd7f697d0a0",
    },
  },
  {
    id: "wind-turbine",
    name: "Wind Turbine",
    value: "WindTurbine",
    category: "industrial",
    service: "Power",
    description: "A wind turbine is a machine that converts the wind's kinetic energy into electricity.",
    defaultHeightAboveGround: 0.2,

    embed: {
      type: "doc360",
      id: "7872ac8b-c002-4a2c-9103-ca448c775f29",
    },
  },
];

/**
 * Combined Simple Structural archetypes.
 */
export const defaultSimpleStructuralArchetypes = [
  ...defaultSimpleResidentialArchetypes,
  ...defaultSimpleCommercialArchetypes,
  ...defaultSimpleIndustrialArchetypes,
];
